import { mergeClassName } from '@chain-zen/ui'

import type { IPublicPostData } from '../../types/post'
import CardView from './card-view'
import TableView from './table-view'

interface BackhaulContentProps {
  className?: string
  posts: IPublicPostData[]
  postsView: 'card' | 'table'
  workspacename: string
  enterpriseWorkspaceID?: string | null | undefined
}

export function BackhaulContent({
  postsView,
  posts,
  workspacename,
  className,
  enterpriseWorkspaceID
}: BackhaulContentProps) {
  return (
    <div className={mergeClassName('w-full', className)}>
      {postsView === 'card' ? (
        <CardView posts={posts} workspacename={workspacename} enterpriseWorkspaceID={enterpriseWorkspaceID} />
      ) : (
        <TableView postsData={posts} workspacename={workspacename} enterpriseWorkspaceID={enterpriseWorkspaceID} />
      )}
    </div>
  )
}
